/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Dialog_TitleInputs */

const he_notifications_dialog_title = /** @type {(inputs: Notifications_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קבלת התראות`)
};

const en_notifications_dialog_title = /** @type {(inputs: Notifications_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Up Notifications`)
};

/**
* | output |
* | --- |
* | "Set Up Notifications" |
*
* @param {Notifications_Dialog_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_dialog_title = /** @type {((inputs?: Notifications_Dialog_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Dialog_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_dialog_title(inputs)
	return en_notifications_dialog_title(inputs)
});